import { RedoCarrierName } from "@redotech/redo-model/carrier-account/carrier-account";
import { groupInput, input, InputSchema } from "@redotech/ui/form";
import { nonEmptyValidator } from "@redotech/ui/validators";
import { AmazonCarrierInput } from "./carrier-forms/create-amazon-carrier-form";
import { ApcCarrierInput } from "./carrier-forms/create-apc-carrier-form";
import { AsendiaCarrierInput } from "./carrier-forms/create-asendia-carrier-form";
import { AustraliaPostCarrierInput } from "./carrier-forms/create-australia-post-carrier-form";
import { CanadaPostCarrierInput } from "./carrier-forms/create-canada-post-carrier-form";
import { CanadaPostDirectCarrierInput } from "./carrier-forms/create-canada-post-direct-carrier-form";
import { CanparCarrierInput } from "./carrier-forms/create-canpar-carrier-form";
import { ChitChatsCarrierInput } from "./carrier-forms/create-chitchats-carrier-form";
import { DHLCarrierInput } from "./carrier-forms/create-dhl-carrier-form";
import { DHLExpressCarrierInput } from "./carrier-forms/create-dhl-express-carrier-form";
import { EPostGlobalCarrierInput } from "./carrier-forms/create-epost-global-carrier-form";
import { ETAExpressCarrierInput } from "./carrier-forms/create-eta-express-carrier-form";
import { FedexCarrierInput } from "./carrier-forms/create-fedex-carrier-form";
import { FedexCrossBorderCarrierInput } from "./carrier-forms/create-fedex-international-carrier-form";
import { FedexSmartpostCarrierInput } from "./carrier-forms/create-fedex-smartpost-carrier-form";
import { FirstMileCarrierInput } from "./carrier-forms/create-first-mile-carrier-form";
import { GlsCarrierInput } from "./carrier-forms/create-gls-carrier-form";
import { OnTracCarrierInput } from "./carrier-forms/create-ontrac-carrier-form";
import { PassportGlobalCarrierInput } from "./carrier-forms/create-passport-global-carrier-form";
import { PurolatorCarrierInput } from "./carrier-forms/create-purolator-carrier-form";
import { RoyalMailCarrierInput } from "./carrier-forms/create-royal-mail-carrier-form";
import { RoyalMailV3CarrierInput } from "./carrier-forms/create-royal-mail-v3-carrier-form";
import { SekoOmniParcelCarrierInput } from "./carrier-forms/create-seko-omni-parcel-carrier-form";
import { SendcloudCarrierInput } from "./carrier-forms/create-sendcloud-carrier-form";
import { SpeeDeeCarrierInput } from "./carrier-forms/create-spee-dee-carrier-form";
import { StallionExpressCarrierInput } from "./carrier-forms/create-stallion-express-carrier-form";
import { UniUniCarrierInput } from "./carrier-forms/create-uniuni-carrier-form";
import {
  UPSCarrierInput,
  UPSSurepostCarrierInput,
} from "./carrier-forms/create-ups-carrier-form";
import { UpsMailInnovationsCarrierInput } from "./carrier-forms/create-ups-mail-innovations-carrier-form";
import { USPSCarrierInput } from "./carrier-forms/create-usps-carrier-form";
import { UspsDirectCarrierInput } from "./carrier-forms/create-usps-direct-carrier-form";
import { UspsShipCarrierInput } from "./carrier-forms/create-usps-ship-carrier-form";
import { VehoCarrierInput } from "./carrier-forms/create-veho-carrier-form";

export const CarrierInput = groupInput({
  name: input<string>({ validator: nonEmptyValidator }),
  redoCarrierName: input<RedoCarrierName>({ validator: nonEmptyValidator }),
  upsCarrierInput: UPSCarrierInput,
  upsSurepostCarrierInput: UPSSurepostCarrierInput,
  upsMailInnovationsCarrierInput: UpsMailInnovationsCarrierInput,
  dhlCarrierInput: DHLCarrierInput,
  dhlExpressCarrierInput: DHLExpressCarrierInput,
  uspsCarrierInput: USPSCarrierInput,
  fedexCrossBorderCarrierInput: FedexCrossBorderCarrierInput,
  fedexCarrierInput: FedexCarrierInput,
  fedexSmartpostCarrierInput: FedexSmartpostCarrierInput,
  vehoCarrierInput: VehoCarrierInput,
  apcCarrierInput: ApcCarrierInput,
  firstMileCarrierInput: FirstMileCarrierInput,
  australiaPostCarrierInput: AustraliaPostCarrierInput,
  canadaPostCarrierInput: CanadaPostCarrierInput,
  canadaPostDirectCarrierInput: CanadaPostDirectCarrierInput,
  royalMailCarrierInput: RoyalMailCarrierInput,
  royalMailV3CarrierInput: RoyalMailV3CarrierInput,
  sekoOmniParcelCarrierInput: SekoOmniParcelCarrierInput,
  glsCarrierInput: GlsCarrierInput,
  asendiaCarrierInput: AsendiaCarrierInput,
  speeDeeCarrierInput: SpeeDeeCarrierInput,
  amazonCarrierInput: AmazonCarrierInput,
  uspsShipCarrierInput: UspsShipCarrierInput,
  uspsDirectCarrierInput: UspsDirectCarrierInput,
  passportGlobalCarrierInput: PassportGlobalCarrierInput,
  epostGlobalCarrierInput: EPostGlobalCarrierInput,
  etaExpressCarrierInput: ETAExpressCarrierInput,
  onTracCarrierInput: OnTracCarrierInput,
  purolatorCarrierInput: PurolatorCarrierInput,
  uniUniCarrierInput: UniUniCarrierInput,
  stallionExpressCarrierInput: StallionExpressCarrierInput,
  chitChatsCarrierInput: ChitChatsCarrierInput,
  sendcloudCarrierInput: SendcloudCarrierInput,
  canparCarrierInput: CanparCarrierInput,
});

export type CarrierInputValue = InputSchema.Value<typeof CarrierInput>;

export type CarrierInputForm = InputSchema.Input<typeof CarrierInput>;
